import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import SidebarNavItemContainer from './SidebarNavItemContainer';

import { useSidebarStore } from '../_useSidebarStore';
import { SIDEBAR_WIDTH } from '@/shared/constants';

import type { SidebarMenuItem } from '../types';

interface GlobalSidebarProps {
  menu: SidebarMenuItem[];
}

/** 전역 사이드바 컴포넌트 (표시할 메뉴는 상위에서 주입) */
export default function GlobalSidebar({ menu }: GlobalSidebarProps) {
  const isMobileDrawerOpen = useSidebarStore((s) => s.isMobileDrawerOpen);
  const setMobileDrawerOpen = useSidebarStore((s) => s.setMobileDrawerOpen);
  const location = useLocation();

  // 라우트 변경 시 드로어 닫기
  useEffect(() => {
    setMobileDrawerOpen(false);
  }, [location.pathname]);

  // 드로어 열릴 때 body 스크롤 잠금
  useEffect(() => {
    document.body.style.overflow = isMobileDrawerOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileDrawerOpen]);

  return (
    <>
      {/* 백드롭 — 모바일 드로어 열릴 때만 표시 */}
      {isMobileDrawerOpen && <div className='fixed inset-0 z-[49] bg-black/40 md:hidden' onClick={() => setMobileDrawerOpen(false)} aria-hidden='true' />}

      <S.Aside $mobileOpen={isMobileDrawerOpen} className='custom_scroll'>
        <SidebarNavItemContainer menu={menu} />
      </S.Aside>
    </>
  );
}

// --- --- --- Styled Components --- --- --- //
const S = {
  Aside: styled.aside<{ $mobileOpen: boolean }>`
    grid-column-start: 1;
    grid-row-start: 2;
    position: relative;
    overflow: visible;
    font-family: 'Pretendard';

    @media (max-width: 767px) {
      position: fixed;
      top: var(--nav-h);
      left: 0;
      bottom: 0;
      width: ${SIDEBAR_WIDTH.EXPANDED};
      z-index: 50;
      overflow: hidden;
      transform: translateX(${({ $mobileOpen }) => ($mobileOpen ? '0' : '-100%')});
      transition: transform 0.3s ease;
    }
  `,
};
